import { settings } from "../../../../settings/settings-util";
import h from "virtual-dom/h";


export default class SurveyRadioButtonsBuilder
{
    //#region Public Interface

    constructor(settings, mutators = [])
    {
        this._settings = settings;
        this._mutators = mutators;
    }

    initialize(store)
    {
        this._store = store;
    }

    buildRadioButtons(radioConfig, surveyId)
    {
        const selectedIndex = this.getSelectedIndex();
        const options = radioConfig.radioOptions.map((item, index) => this.buildRadioButton(item, index, selectedIndex, surveyId));
        const properties =
        {
            className: this._settings.classNames.surveyRadioButtons || settings.classNames.surveyRadioButtons,
            ariaLabelledBy: `${surveyId}-title`,
            id: `${surveyId}-survey-reasons`,
            onclick: this.buildRadioButtonOnClick(radioConfig),
        };

        return h('ul', properties, options);
    }

    //#endregion



    //#region Helper Methods

    buildRadioButton(option, index, selectedIndex, surveyId)
    {
        const radioButtonClassName  = this._settings.classNames.surveyRadioButton  || settings.classNames.surveyRadioButton;
        const id = `${surveyId}-survey-reason-${index}`;
        
        let properties = {
            type: "radio",
            name: "surveyReasons",
            id: id,
            value: index,
            tabIndex: index === selectedIndex ? 0 : -1,
        };

        properties = this._mutators.reduce((props, mutate) => mutate(props), properties);

        const reasonInput = h("input", properties);

        const reasonLabel = h("label", { for: id }, [reasonInput, option]);

        return h("li", { className: radioButtonClassName }, [reasonLabel]);
    }

    buildRadioButtonOnClick(radioConfig)
    {
        return () =>
        {
            const selectedInput = document.querySelector('input[name = "surveyReasons"]:checked');

            if(selectedInput)
            {
                this._store.dispatch({ type: "SURVEY_REASON_GIVEN", reason: radioConfig.radioOptions[selectedInput.value] , selectedReasonIndex: selectedInput.value });
            }
        };
    }

    getSelectedIndex()
    {
        const selectedInput = document.querySelector('input[name = "surveyReasons"]:checked');

        if (selectedInput) { return parseInt(selectedInput.value, 10); }

        return 0;
    }

    //#endregion
}


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/simple-feedback-overlay/src/builders/surveyRadioButtonsBuilder.js